import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const legalEntityManagement = createApi({
    reducerPath: "legalEntityManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        legalEntityList: builder.mutation({
            query: () => ({
                url: `v1/${locale}/settings/legal-entities`,
                method: "GET",
            }),
        }),

        addLegalEntity: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/legal-entities`,
                method: "POST",
                body: body,
            }),
        }),

        viewLegalEntity: builder.mutation({
            query: (legalEntityId) => ({
                url: `v1/${locale}/settings/legal-entities/${legalEntityId}`,
                method: "GET",
            }),
        }),

        updateLegalEntity: builder.mutation({
            query: ({ body, legalEntityId }) => ({
                url: `v1/${locale}/settings/legal-entities/${legalEntityId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteLegalEntity: builder.mutation({
            query: (legalEntityId) => ({
                url: `v1/${locale}/settings/legal-entities/${legalEntityId}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const { 
    useLegalEntityListMutation,
    useDeleteLegalEntityMutation,
    useAddLegalEntityMutation,
    useViewLegalEntityMutation,
    useUpdateLegalEntityMutation
} = legalEntityManagement;
